import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../authentication/services/authentication.service';
import { ContainerWizardComponent } from '../../../project/component/container-wizard/container-wizard.component';
import { ContainerType } from '../../../shared/models/container.types';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { switchMap, take, tap } from 'rxjs';
import { UserService } from '../../../authentication/services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { nonNil } from '../../../shared/utility';

export type WorkspaceBoxKeys = 'visualProject' | 'imgDb' | 'gallery';

@Component({
    selector: 'app-workspace',
    templateUrl: './workspace.component.html',
    styleUrls: ['./workspace.component.scss'],
    standalone: false,
})
export class WorkspaceComponent implements OnInit {
    userName: string;
    notification: string;
    displayNotification: boolean;
    boxes: { key: WorkspaceBoxKeys; iconSrc: string }[] = [
        {
            key: 'visualProject',
            iconSrc: 'assets/svg/sidebar-nav/visual-icon.svg',
        },
        {
            key: 'imgDb',
            iconSrc: 'assets/svg/sidebar-nav/picdatabase-icon.svg',
        },
        { key: 'gallery', iconSrc: 'assets/svg/sidebar-nav/gallery-icon.svg' },
    ];

    constructor(
        private readonly router: Router,
        private readonly authService: AuthenticationService,
        private readonly modal: NgbModal,
        private userService: UserService,
        private translateService: TranslateService
    ) {}

    ngOnInit() {
        this.authService.initializationFinished$
            .pipe(
                take(1),
                switchMap(() =>
                    this.authService.observableUserAuth().pipe(
                        take(1),
                        tap((user) => {
                            this.userName = user.username;
                        })
                    )
                )
            )
            .subscribe();
        this.userService.getUserNotification().subscribe((data) => {
            if (nonNil(data)) {
                this.notification =
                    data[this.translateService.getCurrentLang()];
                this.displayNotification = true;
            } else {
                this.displayNotification = false;
            }
        });
    }

    onBoxButtonClick(key: WorkspaceBoxKeys) {
        switch (key) {
            case 'gallery':
                this.router.navigate(['communityprojects']);
                break;
            case 'imgDb':
                this.openCreationWizard(ContainerType.IMAGE_DB);
                break;
            case 'visualProject':
                this.openCreationWizard(ContainerType.PROJECT_VISUAL);
                break;
        }
    }

    private openCreationWizard(containerType: ContainerType) {
        const modalRef = this.modal.open(ContainerWizardComponent, {
            size: 'lg',
            modalDialogClass: 'add-project-wizard-modal',
        });

        modalRef.componentInstance.type = containerType;
    }
}
